import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { Button, Card, Form, Modal, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../app/stores/store'

function CloseAccount({ handleClose }: any) {
  const { profileStore, userStore } = useStore()
  const { getData } = userStore
  const [loadingBtn, setLoadingBtn] = useState(false)
  const { t } = useTranslation()
  const [closeAcc, setCloseAcc] = useState({
    userId: getData.id || '',
    password: '',
  })

  const handleSubmit = (e: any) => {
    setLoadingBtn(true)
    e.preventDefault()

    profileStore
      .deleteAccount(closeAcc)
      .catch((err) => console.log(err.response))
      .finally(() => {
        setLoadingBtn(false)
        handleClose()
      })
  }

  const handleInputChange = (e: any) => {
    const { name, value } = e.target
    setCloseAcc({ ...closeAcc, [name]: value })
  }

  const passwordField = [
    {
      name: 'password',
      value: closeAcc.password,
      placeholder: '*******',
    },
  ]

  const buttons = [
    {
      title: t('cancel'),
      onClick: handleClose,
      className: 'text-white payment-button-cancel',
      type: 'button',
    },
    {
      title: loadingBtn ? <Spinner animation='border' variant='light' /> : t('delete'),
      className: 'text-white payment-button-tryagain',
      type: 'submit',
    },
  ]

  return (
    <Card className='newFont prevent-select'>
      <Modal.Header>
        <p className='login-card-title'>{t('profile_page.close_account_title')}</p>
        <Button variant='inherit' onClick={handleClose} className='close me-2 d-flex justify-content-center align-items-center p-0'>
          <i className='fa-regular fa-x icon-size' />
        </Button>
      </Modal.Header>
      <Modal.Body className='card-padding card-font-size'>
        <p>{t('profile_page.close_account_body', {
          email: getData.email
        })}</p>
        <p>
        {t('profile_page.close_account_description')}
          
        </p>
        <Form onSubmit={handleSubmit}>
          <Form.Group className='mb-3 profile-password'>
            {passwordField.map((a, index) => (
              <div key={index}>
                <div className='position-relative'>
                  <Form.Control
                    className='card-input-style'
                    type='text'
                    placeholder={a.placeholder}
                    value={a.value}
                    onChange={handleInputChange}
                    name={a.name}
                  />
                </div>
              </div>
            ))}
          </Form.Group>
          <div className='auction-create-buttons'>
            {buttons.map((button, index) => (
              <button
                key={index}
                onClick={button.onClick}
                disabled={loadingBtn}
                type={button.type === 'submit' ? 'submit' : 'button'}
                className={`text-white ${button.className}`}
              >
                {button.title}
              </button>
            ))}
          </div>
        </Form>
      </Modal.Body>
    </Card>
  )
}
export default observer(CloseAccount)
